export const SHOW_STOREFRONT_PICS_INTERNAL_ID = 'show_storefront_pics';

export const experimentsConfig = [];
